module.exports = __webpack_public_path__ + "media/images/emblems/Reconvilier-coat_of_arms-685f094f9e96bdae62b3a615ce5fc3ce.svg";